export default "__VITE_ASSET__CztiLQyA__"